/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { ArgumentTypes, FunctionPlugin } from './FunctionPlugin';
export class PowerPlugin extends FunctionPlugin {
    power(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('POWER'), Math.pow);
    }
}
PowerPlugin.implementedFunctions = {
    'POWER': {
        method: 'power',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER },
            { argumentType: ArgumentTypes.NUMBER },
        ],
    },
};
